module.exports = __webpack_public_path__ + "662be0c959c9770b79b7293ea2ccb732.png";